import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion'

import './SectionFaq.scss';

const data = {
  title: 'FAQ',
  questions: [
    {
      title: 'Is the book free?',
      answer: 'Yes. You can read it <a href="https://themlsbook.com/read" target="_blank">here</a> in PDF format. In case you need EPUB format, you can buy it on <a href="https://www.amazon.com/dp/B0B216KMM4/qid=1653304321" target="_blank">Amazon</a> .',
    },
    // {
    //   title: 'What bookstores are selling this book?',
    //   answer: 'For now, you can purchase this book in few places in Moscow, Russia: <ul><li><a href="https://themlsbook.com/read" target="_blank"><b>Big Bookstore</b></a><li><a href="https://themlsbook.com/read" target="_blank"><b>Big Bookstore</b></a><li><a href="https://themlsbook.com/read" target="_blank"><b>Big Bookstore</b></a></ul> Please, check first if the item is in stock before coming to the store.',
    // },
    {
      title: 'What does this book cover?',
      answer: 'The first part of the book details supervised learning world. We will thoroughly explain most of the terms - artificial intelligence, data science, machine learning, deep learning, gradient descent, linear regression, overfitting and underfitting, bias and variance errors, basis expansion and regularization. The second part of the book is not published yet, but will cover all the known algorithms, including logit models, maximum margin models, bayesian models, ensemble models (boosting / bagging), tree-based models, and evaluation metrics.',
    },
    {
      title: 'I would like to thank the author. Could I donate?',
      answer: 'If you\'d like to express your appreciation or financially contribute to what I do, you could simply buy a pdf <a href="https://leanpub.com/themlsbook" target="_blank">on Leanpub</a>.'
    },
    {
      title: 'Are there any prerequisites to reading this book?',
      answer: 'There are no strict prerequisites to reading this book. However, basic knowledge of mathematics (incl. derivatives and linear algebra) and inferential statistics (incl. linear/polynomial regressions, and distributions) will undoubtedly help the readers to get the most out of this book.',
    },
    {
      title: 'When could I expect the second part of the book?',
      answer: 'I planned to publish the MLS Part II this summer 2022, but due to other open-source projects with higher priority, I pushed it to late December. Starting 2023, I\'ll roll out chapter by chapter (most likely draft versions). You can make it quicker by purchasing pdf via <a href="https://leanpub.com/themlsbook" target="_blank">Leanpub</a>. Your donation allows me to spend more time on the Machine Learning Simplified book by taking a few days off from my day job.',
    }
  ],
};

const SectionFaq = () => {
  return (
    <div className="section-faq">
      <h2 className="section-faq__title">{ data.title }</h2>

      <Accordion defaultActiveKey="0" flush className="accordeon">
        {data.questions.map(question => (
          <Accordion.Item
            eventKey={question.title}
            key={ question.title }
            className="question"
          >
            <Accordion.Header>
              { question.title }
            </Accordion.Header>
            <Accordion.Body>
              <p dangerouslySetInnerHTML={{__html: question.answer}} />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

export default SectionFaq;
